module.exports = __webpack_public_path__ + "static/img/cloth.e1c57c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/campaign/cloth.jpg
// module id = s+sM
// module chunks = 0